<template>
    <div class="container">

        <div class="jiben">

            <div class="fx" style="width:100%;">
                <div class="RowDetailBox">

                    <div class="RowDetail_list" v-if="callDetail.device">
                        <span class="big">{{ $t('设备号：') }}</span>
                        {{ callDetail.device.length > 0 ? callDetail.device[0].device_no : '' }}
                    </div>
                    <div class="RowDetail_list" v-if="callDetail.device">
                        <span class="big">{{ $t('设备型号：') }}</span>
                        {{ callDetail.device.length > 0 ? callDetail.device[0].device_type : '' }}
                    </div>
                    <div class="RowDetail_list" v-if="callDetail.device">
                        <span class="big">{{ $t('当前状态：') }}</span>
                        {{ callDetail.device.length && callDetail.device[0].online == 1 ? '在线' : '离线' }}
                    </div>
                    <div class="RowDetail_list" v-if="callDetail.device">
                        <span class="big">{{ $t('设备电话卡号码：') }}</span>
                        {{ callDetail.device.length > 0 ? callDetail.device[0].sim_phone : '' }}
                    </div>
                    <div class="RowDetail_list" v-if="callDetail.device">
                        <span class="big">{{ $t('设备当前位置：') }}</span>
                        {{ callDetail.device.length > 0 ? callDetail.device[0].address : '' }}
                    </div>
                    <div class="RowDetail_list">
                        <span class="big">{{ $t('购买时间：') }}</span>
                        {{ AfterSalesInfo.apply_date || '' }}
                    </div>
                    <div class="RowDetail_list">
                        <span class="big">{{ $t('订单编号：') }}</span>
                        {{ AfterSalesInfo.order_id || '' }}
                    </div>
                    <div class="RowDetail_list">
                        <span class="big">{{ $t('销售平台：') }}</span>
                        {{ AfterSalesInfo.sales_platform || '' }}
                    </div>
                    <div class="RowDetail_list">
                        <span class="big">{{ $t('售后状态：') }}</span>
                        {{ AfterSalesInfo.status || '' }}
                    </div>
                    <div class="RowDetail_list">
                        <span class="big">{{ $t('售后详情：') }}</span>
                        {{ AfterSalesInfo.info || '' }}
                    </div>
                    <div class="RowDetail_list">
                        <span class="big">{{ $t('仓库签收时间：') }}</span>
                        {{ AfterSalesInfo.warehouse_receipt_time || '' }}
                    </div>
                    <div class="RowDetail_list">
                        <span class="big">{{ $t('发出快递：') }}</span>
                        {{ AfterSalesInfo.resend_courier || '' }}
                    </div>
                    <div class="RowDetail_list">
                        <span class="big">{{ $t('发出时间：') }}</span>
                        {{ AfterSalesInfo.resend_time || '' }}
                    </div>



                </div>
                <div class="con-map" style="height: 4.5rem" v-if="isMap">
                    <div id="containerMap"></div>
                </div>
            </div>

            <div class="basicR">
                <div style="
            text-align: left;
            font-size: 0.16rem;
            font-weight: 700;
            color: #000;
          ">{{ $t('最近一个月异常数据') }}</div>
                <div class="Table">
                    <div class="title">{{ $t('紧急呼叫') }}</div>
                    <el-table :data="SOS_Data" border height="96" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }">
                        <el-table-column prop="time_begin" :label="$t('时间')" width="170">
                        </el-table-column>
                        <el-table-column prop="address" :label="$t('位置')"> </el-table-column>
                    </el-table>
                </div>
                <div class="Table">
                    <div class="title">{{ $t('超出电子围栏') }}</div>
                    <el-table :data="NotifyFence_Data" border height="96"
                        :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
                        <el-table-column prop="time_begin" :label="$t('时间')"> </el-table-column>
                    </el-table>
                </div>
                <div class="Table">
                    <div class="title">{{ $t('姿态异常') }}</div>
                    <el-table :data="Fall_Data" border height="96" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }">
                        <el-table-column prop="time_begin" width="170" :label="$t('时间')">
                        </el-table-column>
                        <el-table-column prop="address" :label="$t('位置')"> </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import i18n from '../../locales/index'

import { get, post, BASE_URL } from "../../libs/tool";
import {
    saveUserCall,
    userOedit,

    customerList,
    bloodTypeList,
    api_getDeviceAbnormalData,
    getUserCallList,
    getDeliverAfterSalesInfo,
} from "../../api/api";

import jq from "jquery";
export default {
    props: {
        caller: {
            type: String,
            required: true
        },
        cc_job_id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            tid: '',
            isMap: false,
            callDetail: {

            },
            mapObj: null,
            AfterSalesInfo: {},
            SOS_Data: [],
            NotifyFence_Data: [],
            Fall_Data: [],
            sbType: '',
        };
    },
    computed: {

    },
    mounted() {
        this.detailUser()
    },
    watch: {
        caller(newVal) {
            this.detailUser()
            console.log('caller changed:', newVal);
        },
        cc_job_id(newVal) {
            if (newVal) {
                this.detailUser()
            }
        },
    },
    methods: {

        getDeliverAfterSalesInfo(id) {
            let data = {

                device_no: id
            };
            get(getDeliverAfterSalesInfo, data, (res) => {
                if (res.success) {

                    this.AfterSalesInfo = res.data

                } else {
                    // this.$message(res.message);
                }
            });
        },
        GetDeviceAbnormalData(device_imei) {
            let data = {
                device_imei: device_imei,
                date_type: 3,
                // query_date: "2023-12-28",
            };
            get(api_getDeviceAbnormalData, data, (res) => {
                if (res.success) {
                    console.log(res.data, "获取异常数据");
                    this.SOS_Data = res.data.PushSOS;
                    this.NotifyFence_Data = res.data.PushNotifyFence;
                    this.Fall_Data = res.data.PushFall;
                }
            });
        },
        detailUser(row) {
            this.callDetail = {

            }
            let data = {
                // id: row.id,
                caller: this.caller,

            };
            get(getUserCallList, data, (res) => {
                if (res.success) {
                    if (res.data.length > 0) {
                        this.callDetail = res.data[0];
                        console.log(this.callDetail, '来电用户信息');
                        if (this.callDetail.device.length > 0) {

                            this.isMap = true;
                            this.$nextTick(() => {
                                this.initMap(this.callDetail.device[0].lon, this.callDetail.device[0].lat)
                            })
                            this.getDeliverAfterSalesInfo(this.callDetail.device[0].device_no)
                            this.GetDeviceAbnormalData(this.callDetail.device[0].device_no);

                        } else {

                        }
                    }


                } else {
                    this.$message(res.message);
                }
            });
        },
        initMap(lng, lat) {
            console.log(lng, lat, 'ddddddfffffff====');
            console.log('地图容器是否存在：', !!document.getElementById('containerMap'))
            console.log('AMap对象是否加载：', window.AMap ? '已加载' : '未加载')

            if (!window.AMap) {
                console.error('请先加载高德地图API')
                return
            }
            this.mapObj = new AMap.Map("containerMap", {
                resizeEnable: true,
                view: new AMap.View2D({
                    center: new AMap.LngLat(lng, lat),
                    zoom: 16,
                }),
            });
            // 添加标记点（带悬浮信息窗）
            var marker = new AMap.Marker({
                icon: new AMap.Icon({
                    //复杂图标
                    size: new AMap.Size(40, 40), //图标大小
                    image: 'https://ylfwapi.aiqiangua.com/ylfw-nextg/fore-end_images/last_loc.png', //大图地址
                    //    imageOffset:new AMap.Pixel(-28,0)//相对于大图的取图位置
                }),
                position: new AMap.LngLat(Number(lng), Number(lat)),
            });
            var info = [];

            // info.push('20202020202');
            // info.push('哈哈哈哈哈哈哈哈哈');

            var inforWindow = new AMap.InfoWindow({
                position: new AMap.LngLat(Number(lng), Number(lat)),
                offset: new AMap.Pixel(10, -23),
                content: info.join("<br>"),
            });
            AMap.event.addListener(marker, "click", function (e) {
                inforWindow.open(this.mapObj, marker.getPosition());
            });
            marker.setMap(this.mapObj); //在地图上添加点
            // marker.setTitle(title);

            this.mapObj.add(marker);

        },

    }
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">



.jiben{
    height: 500px;
    overflow-y: scroll;
}
.RowDetailBox {
        width:480px;
        position: relative;
        min-height: 250px
        .RowDetail_list {
            margin-bottom: 15px;

            .big {
              display: inline-block;
                min-width: 130px;
                color: #000;
                font-weight: 700;
            }
        }
    }
  
  .con-map {
  height: 400px !important;  /* 或使用 flex: 1 */
  width: 600px;
  position: relative;
}
#containerMap {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/CallTab/device.vue